<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'app',
  components: { },

  data() {
    return {

    };
  },
  created() {

  },
};
</script>
